import { render, staticRenderFns } from "./GerenciamentoGrupos.vue?vue&type=template&id=c58bd372&scoped=true"
import script from "./GerenciamentoGrupos.vue?vue&type=script&lang=js"
export * from "./GerenciamentoGrupos.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoGrupos.vue?vue&type=style&index=0&id=c58bd372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58bd372",
  null
  
)

export default component.exports